import { render, staticRenderFns } from "./deleteOwnerRoomList.vue?vue&type=template&id=8265efa2&scoped=true"
import script from "./deleteOwnerRoomList.vue?vue&type=script&lang=js"
export * from "./deleteOwnerRoomList.vue?vue&type=script&lang=js"
import style0 from "./deleteOwnerRoomList.vue?vue&type=style&index=0&id=8265efa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265efa2",
  null
  
)

export default component.exports